module.exports = __webpack_public_path__ + "img/marketing_en@2x.e1585145.png";